import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ep-three-one',
  templateUrl: './ep-three-one.component.html',
  styleUrls: ['./ep-three-one.component.scss']
})
export class EpThreeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
